// Gate for promoting a release out of testing: every AUT lane the release ran must have
// finished, and none of them may report failures. kind and EKS/RDS lanes count equally.
export const RELEASE_AUT_KEYS = [
  'aut_psql',
  'aut_mysql',
  'aut_psql_v2',
  'aut_mysql_v2',
  'aut_psql_kind',
  'aut_mysql_kind',
];

export function checkTestsAreValid(release, user) {
  const testingData = release?.build_status?.testing;
  if (user && user.role === 'admin') {
    return { isValid: true, message: "Admin with bypass right" };
  }
  if (!testingData || testingData.length === 0) {
    return { isValid: false, message: "No test results available" };
  }

  let hasPassingTests = false;
  let hasRunningTests = false;
  let hasFailedTests = false;

  const validateAutTest = (testData) => {
    if (!testData) return;

    const { status, outcome } = testData;

    switch (status) {
      case "completed":
        // A retrieval failure is recorded as a completed lane with no outcome, so an absent
        // or malformed report means this lane's real result is unknown, not that it passed.
        if (typeof outcome?.unexpected !== 'number') {
          hasFailedTests = true;
        } else if (outcome.unexpected > 0) {
          hasFailedTests = true;
        } else {
          hasPassingTests = true;
        }
        break;
      case "running":
      case "pending":
      case "paused":
        hasRunningTests = true;
        break;
      case "errored":
      case "cancelled":
        hasFailedTests = true;
        break;
      default:
        // An unrecognised status is not evidence that the lane passed.
        hasFailedTests = true;
        break;
    }
  };

  const last_run = testingData[testingData.length - 1];
  RELEASE_AUT_KEYS.forEach((key) => validateAutTest(last_run[key]));

  if (hasFailedTests) {
    return { isValid: false, message: "Failed tests" };
  }

  if (!hasPassingTests) {
    return { isValid: false, message: "No passing tests found" };
  }

  if (hasRunningTests) {
    return { isValid: false, message: "Tests are still running" };
  }

  return { isValid: true, message: "" };
}
